import * as openpgp from "openpgp";
import { readFileFromBase64 } from "./readFileFromBase64";
import { readAsBase64 } from "./readAsBase64";
import { logger } from "./logger";

export interface ISingleBinaryKeys {
  PublicKey: string;
  PrivateKey: string;
  cleanPublicKey: openpgp.key.KeyResult;
  cleanPrivateKey: openpgp.key.KeyResult;
}

export const generateSingleBinaryFromMultiplePublicKeys = async (
  publicKeys: string[],
): Promise<ISingleBinaryKeys> => {
  let encryptionKeys: openpgp.key.Key[] = [];

  encryptionKeys = await Promise.all(
    publicKeys.map(async (publicKey) => {
      const keyBuffer = await readFileFromBase64(
        publicKey,
        "application/other",
      );
      try {
        const armored = new TextDecoder().decode(keyBuffer);
        const key = await openpgp.key.readArmored(armored);

        if (key.keys.length) return key.keys[0];
      } catch {
        console.error("Failed to decode key");
      }

      const notArmoredKey = await openpgp.key.read(new Uint8Array(keyBuffer));
      return notArmoredKey.keys[0];
    }),
  );

  const options: openpgp.KeyOptions = {
    userIds: [
      {
        name: "1testowyklucz",
      },
    ],
    curve: "secp256k1",
    numBits: 2048,
  };
  const key = await openpgp.generateKey(options);

  const pubDecoded = await openpgp.key.readArmored(key.publicKeyArmored);
  const privDecoded = await openpgp.key.readArmored(key.privateKeyArmored);
  const publicKeyResultString = new Uint8Array(
    pubDecoded.keys[0].toPacketlist().write(),
  );
  const keyResultString = new Uint8Array(
    privDecoded.keys[0].toPacketlist().write(),
  );
  const { message } = await openpgp.encrypt({
    message: await openpgp.message.fromBinary(keyResultString),
    publicKeys: encryptionKeys,
    armor: false,
  });

  const privateKey = new Uint8Array(message.packets.write());

  logger.log("Private key size:", privateKey.length);

  return {
    PublicKey: await readAsBase64(publicKeyResultString),
    PrivateKey: await readAsBase64(privateKey),
    cleanPublicKey: pubDecoded,
    cleanPrivateKey: privDecoded,
  };
};
